/* eslint-disable import/order */
import React from 'react';
import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import type OpsNotificationsPersonalSettingsType from '@jira/spa-apps__personal-settings-ops-notifications/src/ExportedDefault.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { getNavigationForgePersonalSettingsPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { opsNotificationsPersonalSettingsRoute } from '@jira/router-routes__personal-settings-routes/src/opsNotificationsPersonalSettingsRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { opsNotificationsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import {
	createNotificationPreferencesResource,
	eocUserResource,
	createForwardingRulesResource,
} from '@atlassian/eoc-notifications/resources';
import {
	createMuteResource,
	createQuietHoursResource,
} from '@atlassian/eoc-mute-quiet-hours/resources';
import { createContactsResource } from '@atlassian/eoc-contact-methods/resources';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyOpsNotificationsPersonalSettings = lazyForPaint<
	typeof OpsNotificationsPersonalSettingsType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-personal-settings-ops-notifications", jiraSpaEntry: "async-personal-settings-ops-notifications" */ '@jira/spa-apps__personal-settings-ops-notifications/src/ExportedDefault.tsx'
			),
		),
	{
		ssr: false,
	},
);

const OpsNotificationsPersonalSettingsComponent = () => (
	<LazyPage
		Page={LazyOpsNotificationsPersonalSettings}
		pageId="personal-settings-notifications"
		shouldShowSpinner
	/>
);

export const opsNotificationsPersonalSettingsRouteEntry: Route = createEntry(
	opsNotificationsPersonalSettingsRoute,
	() => ({
		group: 'personal-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: OpsNotificationsPersonalSettingsComponent,
		layout: opsNotificationsLayout,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [
			...getNavigationResources(),
			getConsolidationStateResource(),
			createContactsResource(),
			createNotificationPreferencesResource(),
			eocUserResource,
			createMuteResource(),
			createQuietHoursResource(),
			createForwardingRulesResource(),
			...getNavigationForgePersonalSettingsPageResources(),
		],

		forPaint: [LazyAtlassianNavigation, LazyOpsNotificationsPersonalSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
